import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {Validators, FormBuilder, FormGroup} from "@angular/forms";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {Table} from "../../shared/model/table";
import {TableService} from "../../shared/services/table/table.service";
import {Restaurant} from "../../shared/model/restaurant";
/*
import {TableService} from "../../shared/services/table/table.service";
*/

@Component({
  selector: 'table-create-multiple',
  templateUrl: './table-create-multiple.component.html',
  styleUrls: ['./table-create-multiple.component.css']
})
export class TableCreateMultipleComponent implements OnInit {
    private restaurantId: string;
     currentRestaurantName: string;
    table:Table;
     currentNumberOfTables:number;

    form:FormGroup;
   restaurant: Restaurant;

    constructor(
/*
    private currentRestaurant: Restaurant,
*/

      private tableservice:TableService,
      private restaurantservice:RestaurantService,
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router:Router,
      public modal:Modal,
      overlay:Overlay,
      vcRef:ViewContainerRef
  ) {

      this.form = this.formBuilder.group({
          numberOfTables:['',[Validators.required,Validators.pattern('^(0|[1-9][0-9]*)$')]],
          defaultNumberOfSeats:['',[Validators.required,Validators.pattern('^(0|[1-9][0-9]*)$')]],
          startCount:['',[Validators.required,Validators.pattern('^(0|[1-9][0-9]*)$')]],

      });

        this.table = Object.assign({});
      overlay.defaultViewContainer = vcRef;

      route.data
        .subscribe( ( data : {restaurant:Restaurant  }) =>
          {
            this.restaurant = data.restaurant;
          }

        )

  }

  ngOnInit() {

  this.currentRestaurantName = this.restaurant.restaurant;
    this.restaurantId = this.restaurant.$key;


      this.tableservice.getTables(this.restaurantId)
          .subscribe((tables) => {
              this.currentNumberOfTables  = tables.length;
              this.form.controls['startCount'].setValue(this.currentNumberOfTables+1);
          });

      this.form.controls['defaultNumberOfSeats'].setValue(4);
      this.form.controls['numberOfTables'].setValue(2);

    }


    cancel() {
        this.router.navigate(['/restaurants/'+this.restaurantId])
    }


    isErrorVisible(field:string,error:string){

        return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

    }

    messageIt(titleP: string, messageP: string) {

        this.modal.alert()
            .size('lg')
            .showClose(true)
            .title(titleP)
            .body(messageP)
            .open();
    }


    showErrors(){

        for (let element in this.form.controls){
            for(let element1 in  this.form.controls[element].errors){
                this.form.controls[element].markAsDirty();
            }
        }
    }



    createTables(form:any){

        let numberOfTables = form.numberOfTables;
        let defaultSeats = form.defaultNumberOfSeats;
        let startAt = form.startCount;


        this.modal.confirm()
            .size('lg')
            .showClose(true)
            .title('Create '+ numberOfTables + ' Tables  with ' +defaultSeats+ ' seats  Stating with table ' + startAt)
            .body('Please OK to create tables')
            .open()
            .catch((err: any) => console.log('ERROR: ' + err))
            .then((dialog: any) => { return dialog.result })
            .then((result: any) => { this.createTablesEvent(numberOfTables,defaultSeats,startAt) })
            .catch((err: any) => this._cleanup());

    }

    _cleanup(){
    }



    private createTablesEvent(numberOfTables,defaultSeats,startAt){


        this.table.status = 'Empty';
        this.table.statusForTable = "<span class=\"status-class Empty\">Empty</span>";
        this.table.restaurant_id = this.restaurantId;
        this.table.statusStartedTime =  String(new Date().getTime() / 1000);
        this.table.edit = "<span class=\"glyphicon glyphicon-edit\"></span>";
        this.table.isActive = true;
        this.table.seats = defaultSeats;



        this.tableservice.createMultipleTables(this.table,numberOfTables,startAt);


        this.router.navigate(['/restaurants/'+this.restaurantId])

        this.showErrors()

    }


}



// WEBPACK FOOTER //
// ./src/app/table/table-create-multiple/table-create-multiple.component.ts